module.exports = __webpack_public_path__ + "img/self.a892e61b.svg";